import { Menu, UserLevel } from '@/types';
import { duplicateSampleMenu, workerStatus, notificationsMenu } from './state';
import { menu as user } from './user';

export const menu: Menu = {
  text: 'Admin',
  menu_width: 220,
  menu: [
    {
      text: 'Submit Duplicate Samples',
      click: () => { duplicateSampleMenu.value = true; },
    },
    user,
    {
      text: 'Worker Status',
      click: () => { workerStatus.value = true; },
    },
    {
      text: 'Notifications',
      click: () => { notificationsMenu.value = true; },
    },
  ],
  disallowed: [
    UserLevel.Supervisor,
    UserLevel.Scorer,
    UserLevel.Annotator,
    UserLevel.User,
    UserLevel.Userhigh,
  ],
};
